import createWorld from "./World";

import {
  Tag,
  Data,
  Value,
  Types,
  copyArray,
  copyInstance,
  copyRef,
  copyObject,
  cloneArray,
  cloneInstance,
  cloneRef,
  cloneObject,
} from "./tag";

export {
  createWorld,
  Tag,
  Data,
  Value,
  Types,
  copyArray,
  copyInstance,
  copyRef,
  copyObject,
  cloneArray,
  cloneInstance,
  cloneRef,
  cloneObject,
};
